<ng-container *ngIf="masterProductStatus && masterProductStatus.code && masterProductStatus.name">
    <ng-container *ngIf="masterProductStatus.code === 'S' || masterProductStatus.code === 'TS'; else otherMPS">
        <span class="badge badge-pill py-1 px-3" [ngClass]="'badge-' + masterProductStatus.code">
            {{ masterProductStatus.name }} 
            <ng-container *ngIf="supersessions && supersessions.length">
                <ng-container *ngFor="let product of supersessions; let i = index">
                    <span *ngIf="i === 0">To </span>
                    <span class="partNo" (click)="navigateTo(product.id)">{{ product.partNumber }}</span>
                    <span *ngIf="i + 1 != supersessions.length">, </span>
                </ng-container>
            </ng-container>
        </span>
    </ng-container>
    <ng-template #otherMPS>
        <span class="badge badge-pill py-1 px-3" [ngClass]="'badge-' + masterProductStatus.code">
            {{ masterProductStatus.name }}
        </span>
    </ng-template>
</ng-container>
